import React,{Fragment, Component} from 'react';
import Header from './../../Layout/Header';
import FooterPremium from './../../Layout/FooterPremium';
import PageTitle from './../../Layout/PageTitle';
import bgimg from './../../../images/bg-view.png';

/// modal
import { Modal } from "react-bootstrap";
import { sendContactEmail } from '../../../api/emailsender/EmailSender';
import { serializeForm } from '../../../api/emailsender/formSerialize';

class SubscriptionBox1 extends Component{
	/// model box
	state = {
		// initial state
		show: true,
		appointmentSubmitting: false,
		appointmentError: '',
	}

	handleAppointmentSubmit = async (e) => {
		e.preventDefault();
		const form = e.currentTarget;
		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}
		this.setState({ appointmentSubmitting: true, appointmentError: '' });
		const formData = serializeForm(form);
		formData.formSource = 'Subscription modal box 1';
		const result = await sendContactEmail(formData, 'Star Giga — Virtual project tour registration');
		this.setState({ appointmentSubmitting: false });
		if (result.ok) {
			form.reset();
			this.handleClose();
			alert('Thank you! Our sales team will contact you shortly.');
		} else {
			this.setState({ appointmentError: result.error });
			alert(result.error);
		}
	};

	handleClose = () => {
		this.setState({ show: false });
	};
	handleShow = () => {
		this.setState({ show: true });
	};
	render(){
		return(
			<Fragment>
				<Header />	
				<div className="page-content bg-white">
					{/*  banner  */}
					<PageTitle motherMenu="Subscription Modal Box 1" activeMenu="Subscription Modal Box 1" />
					<div className="content-inner" data-content="PORTFOLIO">				
						<div className="container">
							
							<button className="btn btn-primary" onClick={this.handleShow} type="button" data-toggle="modal" data-target="#exampleModal">Open Modal Box</button>
							{/*  InquiryModal  */}
								
								<Modal show={this.state.show} onHide={this.handleClose} className=" fade inquiry-modal " id="exampleModal" tabindex="-1" >
									<div className="modal-header">
										<h5 className="modal-title" id="exampleModalLongTitle">Register now for a virtual project tour with our sales expert.</h5>
										<button type="button" className="close" onClick={this.handleClose} data-dismiss="modal" aria-label="Close">
										  <span aria-hidden="true">&times;</span>
										</button>
									</div>
									<div className="modal-body">
										<div className="dzFormMsg">
											{this.state.appointmentError && (
												<div className="alert alert-danger">{this.state.appointmentError}</div>
											)}
										</div>
										<form className="dzForm" onSubmit={this.handleAppointmentSubmit}>
											<div className="form-group">
												<input type="text" name="name" required className="form-control" placeholder="Enter Name" />
											</div>
											<div className="form-group">
												<input type="text" name="phone" required className="form-control" placeholder="Enter Phone No." />
											</div>
											<div className="form-group">
												<input type="email" name="email" className="form-control" required placeholder="Enter Email Address" />
											</div>
											<div className="form-group">
												<select className="form-control" name="country" required>
													<option>Select Location</option>
													<option>UK</option>
													<option>India</option>
													<option>Brazil</option>
													<option>Australia</option>
												</select>
											</div>
											<button name="submit" type="submit" value="Submit" className="btn btn-primary btn-block" disabled={this.state.appointmentSubmitting}>
												{this.state.appointmentSubmitting ? 'Sending…' : 'SUBMIT'}
											</button>
										</form>
									</div>
								</Modal>
						</div>
					</div>
					<div>				
						<img src={bgimg} className="bg-view" alt=""/>
					</div>
				</div>
				<FooterPremium />	
			</Fragment>
		)
	}
}
export default SubscriptionBox1;
